import {
  getRequirementList,
  getRequirementListAll,
  getRequirementDetail,
  getRequirementType,
  updateRequirement,
  getRequirementState,
  uploadDeliverableFiles,
  removeDeliverableFiles,
} from '@/api/modules/demand';
import { da } from 'element-plus/es/locale';
type State = {
  pageNum: number;
  pageSize: number;
  total: number;
  tableList: [];
  detailInfo: any;
  demandType: [];
  isRead: boolean
  stateList: any
  loading: boolean
  isManager: boolean
};

const storeState: State = {
  pageNum: 1,
  pageSize: 10,
  total: 0,
  tableList: [],
  detailInfo: {},
  demandType: [],
  isRead: true,
  stateList: [],
  loading: false,
  isManager: false,
};

const actions = {

  async getListState(context: any) {
    const { data } = await getRequirementState();
    context.commit('setStateList', data);
  },
  async getTableList(context: any, params: any) {
    context.commit('setLoading', true);
    let res = {} as any;
    if (params.type == 2) {
      const { data } = await getRequirementListAll(params);
      res = data
    } else {
      const { data } = await getRequirementList(params);
      res = data
    }
    context.commit('setLoading', false);
    context.commit('setTableList', res.list);
    context.commit('setTotal', res.total);
    context.commit('setIsRead', res.isRead);
    context.commit('setIsManager', res.isManager);
  },
  async getDetail(context: any, id: any) {
    const res = await getRequirementDetail(id);
    context.commit('setDetailInfo', res.data);
  },
  async getDemandType(context: any) {
    const res = await getRequirementType();
    context.commit('setDemandType', res.data);
  },
  async updateDemand(context: any, obj: any) {
    const res = await updateRequirement(obj);
    if (res.code === '200') {
      context.dispatch('getDetail', obj.id);
    }
  },
  async uploadDeliverableFiles(context: any, files: any) {
    const res = await uploadDeliverableFiles(files);
    if (res.code === '200') {
      return res.data;
    }
  },
  async removeDeliverableFiles(context: any, files: any) {
    const res = await removeDeliverableFiles(files);
    return res && res.code === '200';
  },
};

// mutations
const mutations = {
  setTableList(state: State, list: any): void {
    state.tableList = list;
  },
  setIsRead(state: State, isRead: any): void {
    state.isRead = isRead;
  },
  setIsManager(state: State, isManager: any): void {
    state.isManager = isManager;
  },
  setTotal(state: State, list: any): void {
    state.total = list;
  },
  setPageSize(state: State, pageSize: any): void {
    state.pageSize = pageSize;
  },
  setPageNum(state: State, pageNum: any): void {
    state.pageNum = pageNum;
  },
  setDetailInfo(state: State, detailInfo: any): void {
    state.detailInfo = detailInfo;
  },
  setDemandType(state: State, demandType: any): void {
    state.demandType = demandType;
  },
  setStateList(state: State, stateList: any): void {
    state.stateList = stateList;
  },
  setLoading(state: any, loading: boolean) {
    state.loading = loading;
  },

};

export default {
  namespaced: true,
  state: storeState,
  actions,
  mutations,
};
